// Styles
import classes from './styles.module.scss'

// utils
import { colorsEnum, rotateEnum, sizeIconEnum } from '@centria-ui/commons/enums'
import { icons } from './svg-icons'

// types
import type { FC, MouseEventHandler } from 'react'

export type IconName = keyof typeof icons

export interface IconComponentProps {
  icon: IconName
  className?: string
  disabled?: boolean
  color?: keyof typeof colorsEnum
  size?: keyof typeof sizeIconEnum
  rotate?: keyof typeof rotateEnum
  onClick?: MouseEventHandler<HTMLElement>
}

export const IconComponent: FC<IconComponentProps> = ({
  icon,
  rotate,
  onClick,
  size = 'md',
  className = '',
  disabled = false,
  color = 'primary'
}) => {
  return (
    <i
      onClick={disabled ? undefined : onClick}
      role={!disabled && onClick ? 'button' : undefined}
      className={`${className} ${classes[size]} ${classes[color]} ${
        rotate && classes[rotate]
      } ${disabled && classes.disabled}`}>
      {icons[icon]()}
    </i>
  )
}
